/**
 * This file is to map if else condition , from and to BE structure, it should contain at least two functions, one that maps
 * from BE to FE structure, and the other one that maps from FE to BE structure
 */
import { ConditionEvents } from "assets/js/scenes/automations/containers/editor/EventsConfigs";
import {
	getEdge,
	getEndCoachmarkNode,
	getStatsStepName,
	getNextTarget,
	getShadowsForStep,
} from "assets/js/scenes/automations/containers/editor/utils/utils";
import {
	getCondition,
	getSingleSwitch,
	getConditionsValues,
	mapCampaignActivitiesToBECorresponders,
	constructOutputCallerVar,
	constructSwitchConditionJson,
	getEvaluationSubAutomationName,
	getNextOfBranch,
} from "./utils/generalUtils";
import {
	getContactDetailsEvaluationSubAutomationName,
	formatRegex,
	formatIntValues,
	getContactDetailsTagEvaluationSubAutomationName,
} from "./utils/contactDetailsUtils";
import deepcopy from "deepcopy";

// need a function to extract the conditions from the switch block

const parseBEIfElseToFE = (automation, mainStep, subStep, targetId) => {
	const events = [];
	const operator = Object.keys(subStep.args.switch[0].condition)[0];
	const conditionsDef = () => {
		return subStep.args.switch[0].condition[operator]
			.map((condition, index) => {
				return getCondition(subStep, automation, condition, index);
			})
			.filter(Boolean);
	};
	const defs = conditionsDef();
	events.push({
		id: mainStep.name,
		position: {
			x: 0,
			y: 0,
		},
		data: {
			name: ConditionEvents()[1].name,
			desc: ConditionEvents()[1].desc,
			type: "condition",
			tileTitle: "app-automation-editor_events_condition-2_tileTitle",
			id: mainStep.name,
			baseId: "ifElse",
			directValue: "all",
			initialElement: false,
			conditions: {
				operator: operator,
				conditions: defs,
			},
			shadows: getShadowsForStep(automation, mainStep.name),
		},
		type: "editorNode",
	});
	const links = [];

	if (
		subStep.args.switch[0].next == "end" ||
		getNextOfBranch(subStep, automation) == "end"
	) {
		const endCoachmark = getEndCoachmarkNode(0, 0);
		events.push(endCoachmark);
		links.push(
			getEdge("branchingEdge", mainStep.name, endCoachmark.id, {
				branchLabel: "Yes",
			})
		);
	} else
		links.push(
			getEdge(
				"branchingEdge",
				mainStep.name,
				getNextOfBranch(subStep, automation),
				{
					branchLabel: "Yes",
				}
			)
		);
	if (targetId && targetId != "end") {
		links.push(
			getEdge("branchingEdge", mainStep.name, targetId, { branchLabel: "No" })
		);
	} else {
		const endCoachmark = getEndCoachmarkNode(0, 0);
		events.push(endCoachmark);
		links.push(
			getEdge("branchingEdge", mainStep.name, endCoachmark.id, {
				branchLabel: "No",
			})
		);
	}

	return {
		events: events,
		links: links,
	};
};
const parseFEIfElseToBE = (FEEvent, connectedEdges, events) => {
	let multipleLists = events.filter(event => event.data.type === "trigger" && event.data.baseId !== "manual").length > 1;
	const mainSteps = [];
	const subAutomationsNames = [];
	const switchConditions = [];
	const prepareSingleMainStep = (condition, index) => {
		let conditionValues = [];
		conditionValues = getConditionsValues(condition, FEEvent.id);
		conditionValues.forEach((conditionValue) => {
			if (conditionValue) {
				// condition value here is the emails step id
				const stepName = getStatsStepName(FEEvent.id, index);
				if (mainSteps.filter((step) => step.name == stepName).length == 0) {
					mainSteps.push({
						name: stepName,
						action: "SubAutomation.Call",
						args: {
							sub_automation: conditionValue.startsWith("a6") ? "sub_get_email_summary_stats" : "sub_get_stats",
							params: {
								trigger_id: "${input.data.step_trigger." + conditionValue + "}",
							},
						},
					});
				}
			}
		});
	};
	/**
	 *
	 * @param {*} type  : one of [clickthru, opened,sent]
	 * * @param {*} triggerIds  : ids of email address that will be evaluated, should be an array
	 */
	const prepareLoopMainStep = (type, triggerIds, index, subAutomationName) => {
		return {
			name: `${FEEvent.id}${index}`,
			action: "SubAutomation.Call",
			args: {
				params: {
					trigger_ids: triggerIds,
					type: type,
				},
				sub_automation: subAutomationName,
			},
		};
	};
	const handleCampaignActivityCondition = (actualCondition, index) => {
		const condition = deepcopy(actualCondition);
		if (condition.campaignsOption == "specific") {
			// get the switch object and push it to the corresponding array
			const currentSwitch = getSingleSwitch(
				condition,
				FEEvent.id,
				`${FEEvent.id}${index}`
			);
			switchConditions.push(currentSwitch);
			// the below function will create the main step and push it to the corresponding array
			prepareSingleMainStep(condition, index);
			if (condition.selectedCamps.length > 0 && condition.selectedCamps[0].startsWith("a6")) {
				subAutomationsNames.push("sub_get_email_summary_stats");
			}
			else {
				subAutomationsNames.push("sub_get_stats");
			}
		} else {
			switch (condition.op) {
				case "and": {
					const subautomationName = getEvaluationSubAutomationName(
						condition.value
					);
					// get the switch object and push it to the corresponding array
					const conditionVar = constructOutputCallerVar(
						`${FEEvent.id}${index}`
					);
					const currentSwitch = constructSwitchConditionJson(
						"eq",
						conditionVar,
						true
					);
					switchConditions.push(currentSwitch);
					// need to add the "get_last_5" sub_automation at the top of the list to make sure it's accessible to all subautomations
					// when needed
					if (
						condition.campaignsOption == "last5" &&
						mainSteps.filter((name) => name == "get_last_5").length == 0
					) {
						mainSteps.unshift({
							action: "SubAutomation.Call",
							args: {
								sub_automation: "get_last_5_of_list",
							},
							name: "get_last_5",
						});
						subAutomationsNames.push("get_last_5_of_list");
					}
					// we need to pass down the name of the sub_automation step that calculates the 5 last emails
					mainSteps.push(
						prepareLoopMainStep(
							mapCampaignActivitiesToBECorresponders(condition.value),
							//input.data.outputs is the parameter holding all the outputs
							condition.value == "5"
								? "${get_last_5_output}"
								: "${input.data.outputs}",
							index,
							subautomationName
						)
					);
					subAutomationsNames.push(subautomationName);
					break;
				}
				case "or": {
					const subautomationName = getEvaluationSubAutomationName(
						condition.value,
						true
					);
					// get the switch object and push it to the corresponding array
					const conditionVar = constructOutputCallerVar(
						`${FEEvent.id}${index}`
					);
					const currentSwitch = constructSwitchConditionJson(
						"eq",
						conditionVar,
						false
					);
					switchConditions.push(currentSwitch);
					// need to add the "get_last_5" sub_automation at the top of the list to make sure it's accessible to all subautomations
					// when needed
					if (
						condition.campaignsOption == "last5" &&
						mainSteps.filter((name) => name == "get_last_5").length == 0
					) {
						mainSteps.unshift({
							action: "SubAutomation.Call",
							args: {
								sub_automation: "get_last_5_of_list",
							},
							name: "get_last_5",
						});
						subAutomationsNames.push("get_last_5_of_list");
					}
					// the below function will create the main step and push it to the corresponding array
					mainSteps.push(
						prepareLoopMainStep(
							mapCampaignActivitiesToBECorresponders(condition.value),
							condition.campaignsOption == "last5"
								? "${get_last_5_output}"
								: "${input.data.outputs}",
							index,
							subautomationName
						)
					);
					subAutomationsNames.push(subautomationName);

					break;
				}

				default:
					break;
			}
		}
	};
	const getListItems = (condition) => {
		if (condition.selectedAttributes[0].name == "email")
			return [{ name: "email", value: "${input.data.contact.email}" }];
		if (condition.selectedAttributes[0].name == "subscribed_on")
			return [
				{ name: "subscribed_on", value: "${input.data.contact.subscribed_on}" },
			];
		else return "${input.data.contact.custom_attributes}";
	};
	const handleTagCondition = (condition, index) => {
		if (condition.selectedTags.length > 0) {
			switch (condition.op) {
				case "or":
					if (condition.value == "noTag") {
						// get the switch object and push it to the corresponding array
						const currentSwitch = {
							eq: { var: `$\{${FEEvent.id}${index}_output}`, value: true },
						};
						switchConditions.push(currentSwitch);
						if (
							mainSteps.filter((step) => step.name == "getContact").length == 0
						) {
							mainSteps.push({
								action: "Contact.Get",
								name: "getContact",
								args: { ...(multipleLists && { "list_id": "input.data.listId" }) },
							});
							mainSteps.push({
								action: "Variable.Set",
								name: "set_output",
								args: {
									"input.data.contact": "${getContact_output.body.data}",
								},
							});
						}
						const evaluationSubAutomationName =
							"evaluate_not_any_values_in_list";
						mainSteps.push({
							action: "SubAutomation.Call",
							name: `${FEEvent.id}${index}`,
							args: {
								sub_automation: evaluationSubAutomationName,
								params: {
									attrVal: "${input.data.contact.tags}",
									values: condition.selectedTags,
								},
							},
						});
						subAutomationsNames.push(evaluationSubAutomationName);
					}
					if (condition.value == "hasTag") {
						// get the switch object and push it to the corresponding array
						const currentSwitch = {
							eq: { var: `$\{${FEEvent.id}${index}_output}`, value: true },
						};
						switchConditions.push(currentSwitch);
						if (
							mainSteps.filter((step) => step.name == "getContact").length == 0
						) {
							mainSteps.push({
								action: "Contact.Get",
								name: "getContact",
								args: { ...(multipleLists && { "list_id": "input.data.listId" }) },
							});
							mainSteps.push({
								action: "Variable.Set",
								name: "set_output",
								args: {
									"input.data.contact": "${getContact_output.body.data}",
								},
							});
						}
						const evaluationSubAutomationName = "evaluate_any_values_in_list";
						mainSteps.push({
							action: "SubAutomation.Call",
							name: `${FEEvent.id}${index}`,
							args: {
								sub_automation: evaluationSubAutomationName,
								params: {
									attrVal: "${input.data.contact.tags}",
									values: condition.selectedTags,
								},
							},
						});
						subAutomationsNames.push(evaluationSubAutomationName);
					}
					break;
				case "and": {
					if (condition.value == "noTag") {
						const currentSwitch = {
							eq: { var: `$\{${FEEvent.id}${index}_output}`, value: true },
						};
						switchConditions.push(currentSwitch);
						if (
							mainSteps.filter((step) => step.name == "getContact").length == 0
						) {
							mainSteps.push({
								action: "Contact.Get",
								name: "getContact",
								args: { ...(multipleLists && { "list_id": "input.data.listId" }) },
							});
							mainSteps.push({
								action: "Variable.Set",
								name: "set_output",
								args: {
									"input.data.contact": "${getContact_output.body.data}",
								},
							});
						}
						mainSteps.push({
							action: "SubAutomation.Call",
							name: `${FEEvent.id}${index}`,
							args: {
								sub_automation: "evaluate_all_not_values_in_list",
								params: {
									attrVal: "${input.data.contact.tags}",
									values: condition.selectedTags,
								},
							},
						});
						subAutomationsNames.push("evaluate_all_not_values_in_list");
					}
					if (condition.value == "hasTag") {
						const currentSwitch = {
							eq: { var: `$\{${FEEvent.id}${index}_output}`, value: true },
						};
						switchConditions.push(currentSwitch);
						if (
							mainSteps.filter((step) => step.name == "getContact").length == 0
						) {
							mainSteps.push({
								action: "Contact.Get",
								name: "getContact",
								args: {},
							});
							mainSteps.push({
								action: "Variable.Set",
								name: "set_output",
								args: {
									"input.data.contact": "${getContact_output.body.data}",
								},
							});
						}
						mainSteps.push({
							action: "SubAutomation.Call",
							name: `${FEEvent.id}${index}`,
							args: {
								sub_automation: "evaluate_all_values_in_list",
								params: {
									attrVal: "${input.data.contact.tags}",
									values: condition.selectedTags,
								},
							},
						});
						subAutomationsNames.push("evaluate_all_values_in_list");
					}
				}
			}
		}
	};

	const handleInterestCondition = (condition, index) => {
		if (condition.contactInterests && condition?.contactInterests?.values.length > 0) {
			let selectedInterests = [];
			condition.contactInterests.values.forEach((value) => {
				selectedInterests.push(value.name);
			});
			switch (condition.contactInterests.condition) {
				case "or":
					// get the switch object and push it to the corresponding array
					if (condition.contactInterests.op == "notinterested") {
						// get the switch object and push it to the corresponding array
						const currentSwitch = {
							eq: { var: `$\{${FEEvent.id}${index}_output}`, value: true },
						};
						switchConditions.push(currentSwitch);
						if (
							mainSteps.filter((step) => step.name == "getContact").length == 0
						) {
							mainSteps.push({
								action: "Contact.Get",
								name: "getContact",
								args: {},
							});
							mainSteps.push({
								action: "Variable.Set",
								name: "set_output",
								args: {
									"input.data.contact": "${getContact_output.body.data}",
								},
							});
						}
						const evaluationSubAutomationName =
							"evaluate_not_any_values_in_list";
						mainSteps.push({
							action: "SubAutomation.Call",
							name: `${FEEvent.id}${index}`,
							args: {
								sub_automation: evaluationSubAutomationName,
								params: {
									attrVal: "${input.data.contact.interests}",
									values: selectedInterests,
								},
							},
						});
						subAutomationsNames.push(evaluationSubAutomationName);
					} else {
						const currentSwitch = {
							eq: { var: `$\{${FEEvent.id}${index}_output}`, value: true },
						};
						switchConditions.push(currentSwitch);
						if (
							mainSteps.filter((step) => step.name == "getContact").length == 0
						) {
							mainSteps.push({
								action: "Contact.Get",
								name: "getContact",
								args: { ...(multipleLists && { "list_id": "input.data.listId" }) },
							});
							mainSteps.push({
								action: "Variable.Set",
								name: "set_output",
								args: {
									"input.data.contact": "${getContact_output.body.data}",
								},
							});
						}
						const evaluationSubAutomationName = "evaluate_any_values_in_list";
						mainSteps.push({
							action: "SubAutomation.Call",
							name: `${FEEvent.id}${index}`,
							args: {
								sub_automation: evaluationSubAutomationName,
								params: {
									attrVal: "${input.data.contact.interests}",
									values: selectedInterests,
								},
							},
						});
						subAutomationsNames.push(evaluationSubAutomationName);
					}
					break;
				case "and": {
					if (condition.contactInterests.op == "notinterested") {
						const currentSwitch = {
							eq: { var: `$\{${FEEvent.id}${index}_output}`, value: true },
						};
						switchConditions.push(currentSwitch);
						if (
							mainSteps.filter((step) => step.name == "getContact").length == 0
						) {
							mainSteps.push({
								action: "Contact.Get",
								name: "getContact",
								args: { ...(multipleLists && { "list_id": "input.data.listId" }) },
							});
							mainSteps.push({
								action: "Variable.Set",
								name: "set_output",
								args: {
									"input.data.contact": "${getContact_output.body.data}",
								},
							});
						}
						mainSteps.push({
							action: "SubAutomation.Call",
							name: `${FEEvent.id}${index}`,
							args: {
								sub_automation: "evaluate_all_not_values_in_list",
								params: {
									attrVal: "${input.data.contact.interests}",
									values: selectedInterests,
								},
							},
						});
						subAutomationsNames.push("evaluate_all_not_values_in_list");
					}
					else {
						const currentSwitch = {
							eq: { var: `$\{${FEEvent.id}${index}_output}`, value: true },
						};
						switchConditions.push(currentSwitch);
						if (
							mainSteps.filter((step) => step.name == "getContact").length == 0
						) {
							mainSteps.push({
								action: "Contact.Get",
								name: "getContact",
								args: { ...(multipleLists && { "list_id": "input.data.listId" }) },
							});
							mainSteps.push({
								action: "Variable.Set",
								name: "set_output",
								args: {
									"input.data.contact": "${getContact_output.body.data}",
								},
							});
						}
						mainSteps.push({
							action: "SubAutomation.Call",
							name: `${FEEvent.id}${index}`,
							args: {
								sub_automation: "evaluate_all_values_in_list",
								params: {
									attrVal: "${input.data.contact.interests}",
									values: selectedInterests,
								},
							},
						});
						subAutomationsNames.push("evaluate_all_values_in_list");
					}
				}
			}
		}
	};


	const handleTriggerDataCondition = (condition, index) => {
		if (condition.selectedAttributes.length > 0) {
			switch (condition.op) {
				case "or":
					let currentSwitch = constructSwitchConditionJson(
						"eq",
						`$\{${FEEvent.id}${index}_output}`,
						false
					);
					switchConditions.push(currentSwitch);
					let evaluationSubAutomationName =
						getContactDetailsEvaluationSubAutomationName(
							condition.selectedAttributesValuesOp,
							condition.selectedAttributes[0],
							true,
						);

					mainSteps.push({
						action: "SubAutomation.Call",
						name: `${FEEvent.id}${index}`,
						args: {
							sub_automation: evaluationSubAutomationName,
							params: {
								attrVal: condition.selectedAttributes[0].value,
								values: condition.selectedAttributesValues.map((val) =>
									formatRegex(
										condition.selectedAttributesValuesOp,
										val
									)),
							},
						},
					});
					subAutomationsNames.push(evaluationSubAutomationName);
					break;
				case "and":
					currentSwitch = constructSwitchConditionJson(
						"eq",
						`$\{${FEEvent.id}${index}_output}`,
						true
					);
					switchConditions.push(currentSwitch);

					evaluationSubAutomationName =
						getContactDetailsEvaluationSubAutomationName(
							condition.selectedAttributesValuesOp,
							condition.selectedAttributes[0],
							false,
						);

					mainSteps.push({
						action: "SubAutomation.Call",
						name: `${FEEvent.id}${index}`,
						args: {
							sub_automation: evaluationSubAutomationName,
							params: {
								attrVal: condition.selectedAttributes[0].value,
								values: condition.selectedAttributesValues.map((val) =>
									formatRegex(
										condition.selectedAttributesValuesOp,
										val
									)),
							},
						},
					});
					subAutomationsNames.push(evaluationSubAutomationName);
					break;
			}
		}
	};

	const handleContactDetailsCondition = (condition, index) => {
		switch (condition.value) {
			case "info":
				if (condition.selectedAttributes.length > 0) {
					switch (condition.op) {
						case "or":
							{
								// get the switch object and push it to the corresponding array
								const currentSwitch = constructSwitchConditionJson(
									"eq",
									`$\{${FEEvent.id}${index}_output}`,
									false
								);
								switchConditions.push(currentSwitch);
								if (
									mainSteps.filter((step) => step.name == "getContact")
										.length == 0
								) {
									mainSteps.push({
										action: "Contact.Get",
										name: "getContact",
										args: { ...(multipleLists && { "list_id": "input.data.listId" }) },
									});
									mainSteps.push({
										action: "Variable.Set",
										name: "set_output",
										args: {
											"input.data.contact": "${getContact_output.body.data}",
										},
									});
								}
								mainSteps.push({
									action: "SubAutomation.Call",
									name: `${FEEvent.id}${index}loop`,
									args: {
										sub_automation: "get_value_list_key",
										params: {
											listItems: getListItems(condition),
											key: condition.selectedAttributes[0].name,
										},
									},
								});

								const evaluationSubAutomationName =
									getContactDetailsEvaluationSubAutomationName(
										condition.selectedAttributesValuesOp,
										condition.selectedAttributes[0],
										true
									);
								mainSteps.push({
									action: "SubAutomation.Call",
									name: `${FEEvent.id}${index}`,
									args: {
										sub_automation: evaluationSubAutomationName,
										params: {
											attrVal:
												condition.selectedAttributes[0].type == "datetime"
													? condition.selectedAttributes[0].name ==
														"subscribed_on"
														? `\${${FEEvent.id}${index}loop_output}`
														: `\${time.parse(text.replace_all(${FEEvent.id}${index}loop_output," ","T")+"Z")}`
													: condition.selectedAttributes[0].type == "integer" &&
														condition.selectedAttributesValuesOp != "eq" &&
														condition.selectedAttributesValuesOp != "ne"
														? `\${int(${FEEvent.id}${index}loop_output)}`
														: `\${${FEEvent.id}${index}loop_output}`,
											values:
												condition.selectedAttributes[0].type == "datetime"
													? condition.selectedAttributesValues.map(
														(val) => `\${time.parse("${val}")}`
													)
													: condition.selectedAttributes[0].type == "integer"
														? condition.selectedAttributesValues.map((val) =>
															formatIntValues(
																condition.selectedAttributesValuesOp,
																val
															)
														)
														: condition.selectedAttributesValues.map((val) =>
															formatRegex(
																condition.selectedAttributesValuesOp,
																val
															)
														),
										},
									},
								});
								subAutomationsNames.push(evaluationSubAutomationName);
								subAutomationsNames.push("get_value_list_key");
							}
							break;
						case "and": {
							// get the switch object and push it to the corresponding array
							const currentSwitch = constructSwitchConditionJson(
								"eq",
								`$\{${FEEvent.id}${index}_output}`,
								true
							);
							switchConditions.push(currentSwitch);
							if (
								mainSteps.filter((step) => step.name == "getContact").length ==
								0
							) {
								mainSteps.push({
									action: "Contact.Get",
									name: "getContact",
									args: { ...(multipleLists && { "list_id": "input.data.listId" }) },
								});
								mainSteps.push({
									action: "Variable.Set",
									name: "set_output",
									args: {
										"input.data.contact": "${getContact_output.body.data}",
									},
								});
							}
							mainSteps.push({
								action: "SubAutomation.Call",
								name: `${FEEvent.id}${index}loop`,
								args: {
									sub_automation: "get_value_list_key",
									params: {
										listItems: getListItems(condition),
										key: condition.selectedAttributes[0].name,
									},
								},
							});

							const evaluationSubAutomationName =
								getContactDetailsEvaluationSubAutomationName(
									condition.selectedAttributesValuesOp,
									condition.selectedAttributes[0],
									false
								);

							mainSteps.push({
								action: "SubAutomation.Call",
								name: `${FEEvent.id}${index}`,
								args: {
									sub_automation: evaluationSubAutomationName,
									params: {
										attrVal: `\${${FEEvent.id}loop_output}`,
										values: condition.selectedAttributesValues,
									},
								},
							});
							subAutomationsNames.push(evaluationSubAutomationName);
							subAutomationsNames.push("get_value_list_key");
						}
					}
				}
				break;
			case "hasTag":
			case "noTag":
				handleTagCondition(condition, index);
				break;
			case "interests":
				handleInterestCondition(condition, index);
			default:
				break;
		}
	};
	FEEvent.data.conditions.conditions.forEach((condition, index) => {
		switch (condition.type) {
			case "ContactDetails":
				handleContactDetailsCondition(condition, index);
				break;
			case "CampaignActivity":
				handleCampaignActivityCondition(condition, index);
				break;
			case "ContactInterests":
				handleContactDetailsCondition(condition, index);
				break;
			case "TriggerData":
				handleTriggerDataCondition(condition, index);
				break;
			default:
				break;
		}
	});
	let shadows = [];
	let inTos = [];
	if (FEEvent.data.shadows) shadows = [...FEEvent.data.shadows];
	inTos = events
		.filter((e) => e.data.baseId == "loop")
		.filter((e) => e.data.goTo == FEEvent.id);
	if (inTos.length > 0) inTos = inTos.map((e) => `${e.id}_loop`);
	const returnedObject = {
		main: [
			{
				steps: [
					{
						name: `${FEEvent.id}`,
						action: "SubAutomation.Call",
						args: {
							sub_automation: FEEvent.id,
						},
						next: "end",
						shadows: shadows,
						inTos: inTos,
					},
				],
			},
		],
		sub: [
			{
				name: FEEvent.id,
				params: [],
				steps: [
					...mainSteps,
					{
						action: "Condition.Switch",
						name: FEEvent.id,
						args: {
							switch: [
								{
									condition: {
										[FEEvent.data.conditions.operator]: switchConditions,
									},
									next: getNextTarget(
										connectedEdges.filter(
											(edge) => edge.data.branchLabel == "Yes"
										),
										events
									),
								},
							],
						},
						next: getNextTarget(
							connectedEdges.filter(
								(edge) => edge.data.branchLabel == "No",
								events
							)
						),
					},
				],
			},
		],
		reusableSubAutomations: subAutomationsNames,
	};
	return returnedObject;
};

export { parseBEIfElseToFE, parseFEIfElseToBE };
